import { Transaction } from './types';

export const ACCOUNTS = ['BCA', 'JAGO', 'Mandiri', 'GoPay', 'OVO'];
export const EXPENSE_CATEGORIES = ['Food', 'Shopping', 'Transport', 'Entertainment', 'Health', 'Bills', 'Other'];
export const INCOME_CATEGORIES = ['Salary', 'Gift', 'Freelance', 'Investment', 'Other'];

export const CATEGORY_EMOJIS: Record<string, string> = {
  Food: '🍔',
  Shopping: '🛍️',
  Transport: '🚗',
  Entertainment: '🎮',
  Health: '💊',
  Bills: '📄',
  Salary: '💼',
  Gift: '🎁',
  Freelance: '💻',
  Investment: '📈',
  Other: '📦',
};

export const ACCOUNT_COLORS: Record<string, string> = {
  BCA: '#005BAA',
  JAGO: '#FF6B35',
  Mandiri: '#003D82',
  GoPay: '#00AED6',
  OVO: '#4C3494',
};

const today = new Date();
const yesterday = new Date(today);
yesterday.setDate(yesterday.getDate() - 1);
const twoDaysAgo = new Date(today);
twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);

export const INITIAL_TRANSACTIONS: Transaction[] = [
  {
    id: '1',
    date: today,
    account: 'BCA',
    category: 'Gift',
    note: 'Dari Robin',
    amount: 500000,
    type: 'income',
  },
  {
    id: '2',
    date: today,
    account: 'BCA',
    category: 'Gift',
    note: 'Dari Robin',
    amount: 500000,
    type: 'income',
  },
  {
    id: '3',
    date: today,
    account: 'BCA',
    category: 'Gift',
    note: 'Dari Robin',
    amount: 500000,
    type: 'income',
  },
];

export function formatRupiah(amount: number): string {
  return `Rp${amount.toLocaleString('id-ID').replace(/,/g, '.')}`;
}

export function parseAmount(value: string): number {
  const cleaned = value.replace(/[^0-9]/g, '');
  return parseInt(cleaned) || 0;
}
